import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { CreditRequestStateService } from '../../features/credit-request/state/credit-request-state.service';

/**
 * Envía el token de tenant recibido en la URL de /home (query `tenant`) como X-App-Token.
 */
export const tenantAppTokenInterceptor: HttpInterceptorFn = (req, next) => {
  if (environment.useMock) {
    return next(req);
  }

  const token = inject(CreditRequestStateService).tenantAppToken();
  if (!token || req.headers.has('X-App-Token')) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: { 'X-App-Token': token },
    }),
  );
};
